KEY_ENTER = 13;
KEY_SPACE = 32;

$.fn.bindClickEvent = function (owner, fn) {
    $(this).off('click').on('click', function (e) {
        e.preventDefault();
        fn.bind(owner)(e);
        return false;
    });
    $(this).off('keyup').on('keyup', clickOnSpace);
}

$.fn.onChangeKeyUp = function (owner, fn) {
    $(this).change(fn.bind(owner)).keyup(fn.bind(owner));
}

$.fn.onTypeAheadChange = function (owner, fn) {
    let node = $(this);

    function callback() {

        let val = node.val();
        setTimeout(function () {

            if (node.val() === val) {
                fn.bind(owner)();
            }

        }, 700);

    }

    node.change(callback).keyup(callback);
}

$.fn.onChangeClickKeyUp = function (owner, fn) {
    $(this).bindClickEvent(owner, fn);
    $(this).onChangeKeyUp(owner, fn);
}

function clickOnSpace(e) {
    let key = e.key || e.keyCode;
    if (key === " " || key === KEY_SPACE || key === 'Enter' || key === KEY_ENTER) {
        let target = $(this);
        target.click();
        e.preventDefault();
    }
}

$.fn.startSaving = function () {
    $(this).disableControl().addClass('app-saving');
    return $(this);
}

$.fn.endSaving = function () {
    $(this).enableControl().removeClass('app-saving');
    return $(this);
}

$.fn.disableControl = function () {
    this.attr('disabled', 'true');
    return $(this);
};

$.fn.enableControl = function () {
    this.removeAttr('disabled');
    return $(this);
};

$.fn.enableIf = function (condition) {
    if (!condition) {
        this.disableControl();
    } else {
        this.enableControl();
    }
    return $(this);
};

$.fn.disableIf = function (condition) {
    return this.enableIf(!condition);
};

$.fn.addClassIf = function (style, condition) {
    if (condition) {
        this.addClass(style);
    } else {
        this.removeClass(style);
    }
    return $(this);
}


$.fn.hideIf = function (condition) {
    $(this).showIf(!condition);
    return $(this);
};

$.fn.showIf = function (condition) {
    if (condition) {
        if ($(this).hasClass('hidden')) {
            $(this).removeClass('hidden');
            $(this).show();
            return true;
        }
        $(this).show();
    } else {
        if (!$(this).hasClass('hidden')) {
            $(this).hide();
            $(this).addClass('hidden');
            return true;
        }
        $(this).hide();
    }
    return false;
};

$.fn.setCheckedIf = function (condition) {
    if (condition) {
        $(this).prop('checked', true);
    } else {
        $(this).prop('checked', false);
    }
}

$.fn.isChecked = function () {
    return $(this).is(':checked');
}

$.fn.isVisible = function () {
    return $(this).is(':visible');
}

$.fn.isHidden = function () {
    return !$(this).is(':visible') || $(this).hasClass('hidden');
}

$.fn.showAnimatedIf = function (condition, animated) {
    let node = $(this);
    if (animated) {
        if (condition && node.hasClass('hidden')) {
            node.removeClass('hidden');
            node.slideDown();
            node.fadeIn();
            return true;
        } else if (!condition && !node.hasClass('hidden')) {
            node.fadeOut();
            node.slideUp(() => node.addClass('hidden'));
            return true;
        }
    } else {
        let wasHidden = node.hasClass('hidden');
        node.addClassIf('hidden', !condition);
        return wasHidden && condition;
    }
    return false;
};

$.fn.highlight = function () {
    let node = $(this);
    node.addClass('highlight');
    setTimeout(function () {
        node.removeClass('highlight');
    }, 500);
}


$.fn.highlight2 = function () {
    let node = $(this);
    node.animate({
        opacity: 0.6
    }, 300, function () {
        node.animate({opacity: 1.0}, 300);
    });
}

$.urlParam = function (name, defaultValue) {
    let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results !== null) {
        return results[1];
    }
    return defaultValue;
};